var formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function openCartdrawer() {
  document.querySelector(".cart-drawer-wrap").classList.add("active");
}

function closeCartdrawer() {
  document.querySelector(".cart-drawer-wrap").classList.remove("active");
}

// function updateCartItemCounts(count) {
//   document.querySelectorAll(".cart-count").forEach((el) => {
//     el.textContent = count;
//   });
// }

async function updateCartdrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();

  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  //update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        //get line item key

        const rootItem = button.parentElement.parentElement.parentElement;
        console.log(rootItem);
        const key = rootItem.getAttribute("data-line-item-key");
        console.log(key);
        //get new quantity
        // const currentQuantity = Number(
        //   button.parentElement.parentElement.querySelector(
        //     ".left .item-quantity span"
        //   ).value
        // );
        // console.log(currentQuantity);

        const currentQuantity = Number(
          button.parentElement.parentElement.querySelector("input").value
        );
        // const currentQuantity = parseInt(currentQuantitySpan.innerHTML, 10);
        console.log(currentQuantity);
        const isRemove = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );

        const newQuantity = isRemove
          ? currentQuantity + 1
          : currentQuantity - 1;
        // console.log(key, newQuantity);

        // console.log({ key, newQuantity });

        //ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const json = await res.json();
        console.log(json);

        // updateCartItemCounts(cart.item_count);
        //update cart
        updateCartdrawer();
      });
    });
  //-----------------------------------------------------
  document.querySelector(".cart-drawer").addEventListener("click", (e) => {
    e.stopPropagation();
  });
  //-----------------------------------------------------
  document.querySelectorAll("#cart-close , .cart-drawer-wrap").forEach((el) => {
    el.addEventListener("click", () => {
      closeCartdrawer();
    });
  });
}

addCartDrawerListeners();

//do nothing when click add to cart button
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    //submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    //update cart
    await updateCartdrawer();

    //oepn cart drawer
    openCartdrawer();
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartdrawer();
  });
});
